exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-final-js": () => import("./../../../src/templates/final.js" /* webpackChunkName: "component---src-templates-final-js" */),
  "component---src-templates-final-menu-js": () => import("./../../../src/templates/final-menu.js" /* webpackChunkName: "component---src-templates-final-menu-js" */)
}

